import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(input: string | number): string {
  const date = new Date(input);
  return date.toLocaleDateString("sv-SE", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("sv-SE", {
    style: "currency",
    currency: "SEK",
    minimumFractionDigits: 0,
  }).format(amount);
}

export function getInitials(name: string): string {
  if (!name) return "";

  const parts = name.split(" ");
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();

  return (
      parts[0].substring(0, 1).toUpperCase() +
      parts[parts.length - 1].substring(0, 1).toUpperCase()
  );
}

export function calculateProfileCompletion(user: any): number {
  if (!user) return 0;

  const requiredFields = [
    'firstName',
    'lastName',
    'email',
    'bio',
    'university',
    'program'
  ];

  const completedFields = requiredFields.filter(field =>
      !!user[field] && user[field].trim() !== ''
  );

  return Math.round((completedFields.length / requiredFields.length) * 100);
}